import { render } from "./VehicleReportPrint.vue?vue&type=template&id=1d448778&ts=true"
import script from "./VehicleReportPrint.vue?vue&type=script&lang=ts"
export * from "./VehicleReportPrint.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
